"use client";

import { DockSkeleton } from "./Dock";
import { WarehouseFlowSkeleton } from "./warehouseFlow/WarehouseFlowPhoneBoard";
export function DesktopShellSkeleton() {
  return <div className="fixed inset-0 overflow-hidden bg-offwhite" aria-busy inert data-sentry-component="DesktopShellSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx">
            <WarehouseFlowSkeleton data-sentry-element="WarehouseFlowSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx" />
            <DockSkeleton data-sentry-element="DockSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx" />
        </div>;
}